import { createSelector } from "reselect";

const selectCashInOut = (state) => state.cashInOut;

export const selectReasonCodes = createSelector(
  [selectCashInOut],
  (cashInOut) => cashInOut.reasonCodes
);

export const selectEmployees = createSelector(
  [selectCashInOut],
  (cashInOut) => cashInOut.employees
);

export const selectWarehouses = createSelector(
  [selectCashInOut],
  (cashInOut) => cashInOut.warehouses
);

export const selectPointOfSales = createSelector(
  [selectCashInOut],
  (cashInOut) => cashInOut.pointOfSales
);

export const selectSessionKeyUser = createSelector(
  [selectCashInOut],
  (cashInOut) => cashInOut.sessionKeyUser
);

export const selectStoreRegions = createSelector(
  [selectCashInOut],
  (cashInOut) => cashInOut.storeRegions
);
